var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRectangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 4h120v120H4z",
    stroke: "#FFF",
    strokeWidth: 8,
    fill: "none",
    fillRule: "evenodd"
  })));
}
export default SvgRectangle;